// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';

export function pixOutgoingPaymentMapper(): $Shape<OutgoingPayment> {
  return {
    payment_type: 'pix',
    payment_type_code: 'pix',
  };
}
